import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
    page: {
        display: 'flex'
    },
    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700'
    },
    text: {
        color: '#535353',
        fontFamily: 'Montserrat',
        marginTop: 24
    }
});